import React, { Component } from "react";
import { Card, Form, Icon, Input, Button, message } from "antd";
import { connect } from "react-redux";
import { logIn } from "../../store/actions/session";
import "./login.scss";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class Login extends Component {
  state = { loginLoading: false };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { logIn } = this.props;
        this.setState({ loginLoading: true });
        logIn(values)
          .then(() => {
            message.success("登入成功");
            window.location.href = "/net-zero/home";
            this.setState({ loginLoading: false });
          })
          .catch((e) => {
            console.error(e);
            message.error("登入失敗");
            this.setState({ loginLoading: false });
          });
      }
    });
  };

  render() {
    const { loginLoading } = this.state;
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } =
      this.props.form;

    const passwordError =
      isFieldTouched("password") && getFieldError("password");

    return (
      <Card
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          backgroundColor: "#f0f2f5",
          textAlign: "center",
        }}
        bordered={false}
      >
        <img
          style={{
            width: "200px",
            height: "52px",
            marginBottom: 24,
            borderRadius: 5,
          }}
          src="/logo.png"
          alt="logo"
        />
        <Form onSubmit={this.handleSubmit} id="LoginForm">
          <Form.Item>
            {getFieldDecorator("account", {
              initialValue: "",
              rules: [
                {
                  required: true,
                  message: "請輸入帳號",
                },
              ],
            })(
              <Input
                prefix={
                  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="請輸入帳號"
              />
            )}
          </Form.Item>

          <Form.Item
            style={{ marginBottom: "1.5em" }}
            validateStatus={passwordError ? "error" : ""}
            help={passwordError || ""}
          >
            {getFieldDecorator("password", {
              initialValue: "",
              rules: [
                {
                  required: true,
                  message: "請輸入密碼",
                },
              ],
            })(
              <Input.Password
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="請輸入密碼"
              />
            )}
            {/* <div className="forget-block">
              <a href="/forget">忘記密碼？</a>
            </div> */}
          </Form.Item>

          <Form.Item>
            <Button
              loading={loginLoading}
              type="primary"
              block
              htmlType="submit"
              disabled={hasErrors(getFieldsError())}
            >
              登入
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  logIn: async (loginDetails) => dispatch(logIn(loginDetails)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(Login));
